import * as React from 'react';
import * as request from 'superagent';
import  {
    withStyles,
    WithStyles,
    StyleRules,
    ClassNameMap
} from '@mui/styles';
import { Theme } from '@mui/styles';
import LoadingView from '~common/components/loading-view';
import { Typography } from '@mui/material';
import { APIError } from '~common/lib/types';
import URLManager from '~common/lib/url-manager';
import classNames from 'classnames';
import Renderers from '~common/lib/renderers';

const styles = (theme: Theme): StyleRules => ({
    cardContent: {
        margin: '10px 15px 10px 15px',
        height: 'calc(100% - 70px)'
    },
    templateContent: {
      width: "100%"
    },
    contentContainer: {
        display: 'flex',
        width: '100%',
        height: '100%'
    },

});

interface Props {
    id: number;
    renderers: any;
    element: any;

    chromeless?: boolean;

    elementType: any;

    inEditMode?: boolean;

}

type State = {
    status: 'loading' | 'ready';
    data: any;
    error?: any;
};

class TemplateRenderer extends React.Component<
    Props & WithStyles<keyof typeof styles>,
    State
    > {
    constructor(props: Props & WithStyles<keyof typeof styles>) {
        super(props, {});
        this.state = {
            status: 'loading',
            data: null
        };
    }

   componentDidMount() {
        const self = this;
        if (!this.props.element || !this.props.element.id) {
            console.error("No ID found on Props")
        } else {
            if (this.props.element.fulfillmentURL) {
            // self.setState({ status: 'ready' })
            request
              .get('/api/dashboards/' + this.props.element.id)
              .set('accept', 'application/json')
              .send()
              .then((response) => {
                // console.log("template response", response)
                self.setState({status: 'ready', data: response.body});
              })
              .catch((err) => {
                if (err.response && err.response.text) {
                  const apiErr = new APIError();
                  apiErr.type = 'http';
                  apiErr.message = err.response.text;
                  self.setState({status: 'ready', error: apiErr});
                }
              });
            } else {
                self.setState({status: 'ready', data: {element: this.props.element}})
            }
        }
    }

    static register = () => {
        if (!Renderers.find("TemplateElementRenderer")) {
            Renderers.register("TemplateElementRenderer", withStyles(styles)(TemplateRenderer))
        }
    }


    getThresholdAttributes = (): any => {
        const { data } = this.state;

        let attr = {};

        if (
            data.element.elementAttributes &&
            data.element.elementAttributes.thresholds
        ) {
            const thresholds = data.element.elementAttributes.thresholds;

            if (thresholds.defaultAttributes) {
                attr = thresholds.defaultAttributes;
            }
            if (thresholds.entries) {
                var sorted = thresholds.entries.sort((a, b) => {
                    return a.value > b.value;
                });

                for (let i of sorted) {
                    if (i.floorValue <= data.content.count && i.attributes) {
                        attr = i.attributes;
                    }
                }
            }
        }

        return attr;
    };

    getAlignItemsAttribute = (): string => {
        var {data} = this.state
        if (data && data.element && data.element.elementAttributes && data.element.elementAttributes.templateAttributes) {
            if (data.element.elementAttributes.templateAttributes.alignItems) {
                return data.element.elementAttributes.templateAttributes.alignItems
            }
        }
        return "center"
    }

    getJustifyContentAttribute = () => {
        var {data} = this.state
        if (data && data.element && data.element.elementAttributes && data.element.elementAttributes.templateAttributes) {
            if (data.element.elementAttributes.templateAttributes.justifyContent) {
                return data.element.elementAttributes.templateAttributes.justifyContent
            }
        }
        return "center"
    }

    render() {
        const { classes }: { classes: ClassNameMap } = this.props;
        const { chromeless, renderers } = this.props;
        const { status, data } = this.state;

        var cardContent: any = null;
        

        switch (status) {
            case 'loading':
                return (
                    <div className={classes.container}>
                        <LoadingView compact classes={{}} />
                    </div>
                );

            default:
                if (data && data.element ) {
                    const styleAttributes = this.getThresholdAttributes();

                    var content:string = data.content
                    if(!content) {
                      content = data.element.elementAttributes.template
                    }

                    var renderer: any = null;
                    cardContent = (
                            <div
                                className={classes.templateContent}
                                style={styleAttributes}
                                dangerouslySetInnerHTML={{__html: content}}
                            />
                    );
                }
        }


        return <div style={{alignItems: this.getAlignItemsAttribute(), justifyContent: this.getJustifyContentAttribute()}} className={classes.contentContainer}>{cardContent}</div>;

    }
}

export default withStyles(styles)(TemplateRenderer);

